import React, { useEffect, useState } from 'react';
import { Container, Grid, TextField, Button, Typography } from '@mui/material';
import { toggleSwipe } from '../features/Search/searchSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  setViewportHeight,
  setViewportWidth,
  setScale,
  selectViewportHeight,
  selectViewportWidth,
  selectViewportScale,
} from '../features/Auth/authSlice';

const ViewportSettings = () => {
  const viewportHeight = useSelector(selectViewportHeight);
  const viewportWidth = useSelector(selectViewportWidth);
  const scale = useSelector(selectViewportScale);
  const dispatch = useDispatch();
  const handleNativeMessage = (event) => {
    try {
      const message = JSON.parse(event.data);
      console.log(message, 'message');
      if (message.type == 'viewport') {
        console.log('Received viewport settings from React Native:', message);
        dispatch(setViewportWidth(message.width));
        dispatch(setViewportHeight(message.height));
        dispatch(setScale(message.scale));
      }
    } catch (error) {
      console.error('Error parsing message from React Native:', error);
    }
  };

  useEffect(() => {
    // Add event listener for messages from React Native
    window.addEventListener('message', handleNativeMessage);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleNativeMessage);
    };
  }, []);

  const handleWidthChange = (event) => {
    dispatch(setViewportWidth(event.target.value));
  };

  const handleHeightChange = (event) => {
    dispatch(setViewportHeight(event.target.value));
  };

  const handleScaleChange = (event) => {
    dispatch(setScale(event.target.value));
  };

  const sendViewportSettings = () => {
    const message = JSON.stringify({
      type: 'viewport',
      width: parseInt(viewportWidth),
      height: parseInt(viewportHeight),
      scale: parseFloat(scale),
    });

    // Send message to React Native WebView
    dispatch(toggleSwipe({ value: false }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: false }));
    window['ReactNativeWebView'] && window['ReactNativeWebView'].postMessage(message);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" component="h2" gutterBottom align="center">
        Viewport Settings
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Viewport Width"
            type="number"
            value={viewportWidth}
            onChange={handleWidthChange}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Viewport Height"
            type="number"
            value={viewportHeight}
            onChange={handleHeightChange}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Scale"
            type="number"
            step="0.1"
            value={scale}
            onChange={handleScaleChange}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={sendViewportSettings} fullWidth>
            Apply Settings
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ViewportSettings;
